module.exports = __webpack_public_path__ + "img/9788960170612.1cc63981.jpg";